import request from "@/utils/request";
const sendPhoneNumberToken = async ({ userId, phoneNumber, }) => {
    const data = {
        userId,
        phoneNumber,
    };
    const result = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/api/account/send-phone-number-confirmation-token`, {
        method: "POST",
        data,
    });
    return result.data;
};
export default sendPhoneNumberToken;
